export default __webpack_public_path__ + "static/media/frame.52e0d6e7.png";